module.exports = __webpack_public_path__ + "adidas.svg?c3b5181492faf45a0acd9268f4ad85f4";